/** @format */

import { combineReducers } from "redux";
import auth from "./auth";
import appToken from "./appToken";
import userProfile from "./userProfile";
import sellerListing from "./sellerListing";
import currencyConverter from "./currencyConverter";
import checkout from "./checkout";
import searchListing from "./searchListing";
import pageRefresh from "./refresh"
import recommendations from "./recommendations"
import cartProductsQuantity from "./cartProductsQuantity";


const createRootReducer = () =>
  combineReducers({
    appToken: appToken,
    auth: auth,
    userProfile: userProfile,
    sellerListing: sellerListing,
    currencyConverter: currencyConverter,
    checkout: checkout,
    searchListing: searchListing,
    pageRefresh: pageRefresh,
    recommendations : recommendations,
    cartProductsQuantity:cartProductsQuantity,
  });

export default createRootReducer;
